import React, { useMemo } from 'react';
import { BodyButton } from './bodyStyle.style';
import { BodyTypeFilterResultCounts, FilterOption } from '../../../types';
import { FilterTypes } from '../../../constants/initialFilters';
import CheckMarkIcon from '../../../assets/icons/CheckMarkIcon';

type BodyType = keyof BodyTypeFilterResultCounts;
interface BodyTypes {
  body: BodyType;
  filterType: string;
  bodyTypeOptions: {
    [key: string]: FilterOption;
  };
  confirmedFilters: FilterTypes;
  availableFilters: string[];
  handleAddFilter: (filterType: string, value: string, isChecked?: boolean) => void;
}

const Body: React.FC<BodyTypes> = ({
  body,
  filterType,
  bodyTypeOptions,
  confirmedFilters,
  handleAddFilter,
  availableFilters,
}) => {
  const { value, label } = bodyTypeOptions[body] as {
    value: string;
    label: string;
  };

  const isSelected = confirmedFilters.bodyType.includes(value);

  const isAvailable = useMemo(() => {
    return !!availableFilters.includes(body);
  }, [availableFilters, body]);

  return (
    <BodyButton
      type="button"
      key={value}
      disabled={!isAvailable}
      onClick={() => handleAddFilter(filterType, value, isSelected)}
      data-testid={`bodyStyle-${value}`}
      isSelected={isSelected}
      isAvailable={isAvailable}
    >
      {isSelected && <CheckMarkIcon size={24} />}
      {label}
    </BodyButton>
  );
};

export default Body;
